<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :has-details-row="true"
            :per-page="250"
            :selectable-rows="false"
          >
            <template #head(company)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.company"
                input-type="number"
              />
            </template>
            <template #head(customerNumber)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.customerNumber" />
            </template>
            <template #head(year)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.year"
                input-type="number"
              />
            </template>
            <template #head(period)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.period"
                input-type="number"
              />
            </template>
            <template #head(sales)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.sales"
                input-type="number"
              />
            </template>
            <template #head(periodDescription)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.periodDescription" />
            </template>
            <template #head(primaryKey)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.primaryKey" />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>        

<script>
import {CustomerMixin} from '../../../mixins';
import DataTable from '../../table/data-table';
import TableFilter from '../../table/table-filter';
import PageHeader from '../../structure/page-header';

export default {
  name: 'CustomerStatistics',
  components: {DataTable, TableFilter, PageHeader},
  mixins: [CustomerMixin],
  data: function () {
    return {
      table: {
        selectedRow: null,
        rows: [],
        fields: [
          {key: 'company', label: this.$translate('company')}, 
          {key: 'customerNumber', label: this.$translate('account')},
          {key: 'year', label: this.$translate('year')},
          {key: 'period', label: this.$translate('period'), thClass: 'number-column', tdClass: 'number-column'},
          {key: 'periodDescription', label: this.$translate('period_description'), thClass: ['wide', 'number-column'], tdClass: ['wide', 'number-column']},
          {key: 'sales', label: this.$translate('sales'), thClass: ['wide', 'number-column'], tdClass: ['wide', 'number-column']},
          {key: 'primaryKey', label: this.$translate('primary_key'), thClass: ['wide', 'number-column'], tdClass: ['wide', 'number-column']},
          {key: 'timestampUpdate', label: this.$translate('timestamp_update'), thClass: ['wide', 'number-column'], tdClass: ['wide', 'number-column']},
        ],
        filter: {
          company: null,
          customerNumber: null,
          year: null,
          period: null,
          periodDescription: null,
          sales: null,
          primaryKey: null,
        }
      }
    };
  },
  methods: {
    async getPage(params) {
      try {
        const response = await this.customerService.getStatistics(params);
        return {totalCount: response.totalCount, data: response.data};
      } catch (err) {
        this.showNotification({type: 'error', message: err.message});
      }
    }
  }
};
</script>

<style scoped lang="scss">
  ::v-deep   table {
    min-width: 800px;

    th, td {
      width: 16.67%;

      &.wide {
        width: 25%
      }
    }
  }
</style>
